export const tabsList = [
  {
    tabName: '告警消息',
    tabKey: 'alarm',
    tabAccount: 0
  },
  {
    tabName: '系统通知',
    tabKey: 'system',
    tabAccount: 0
  },
  {
    tabName: '业务通知',
    tabKey: 'biz_notice',
    tabAccount: 0
  }
  
]
export const urgentS = {
  1: '紧急',
  2: '一般',
  3: '重大紧急'
}
